// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDHAoL0l0w4lHloCiwgdixZO-8mt-L20dI",
  authDomain: "hackfrost-57ef6.firebaseapp.com",
  projectId: "hackfrost-57ef6",
  storageBucket: "hackfrost-57ef6.appspot.com",
  messagingSenderId: "445771341363",
  appId: "1:445771341363:web:23b9a0beb03d8d3f100d46",
  measurementId: "G-C9HLDG51V3",
};

// Initialize services
const app = initializeApp(firebaseConfig);
const auth = getAuth();
const db = getFirestore();
const analytics = getAnalytics(app);

export { app, db, auth };
